export function removeDuplicatedObjectsByKey<T, K extends keyof T>(arrayWithDuplicates: T[], key: K): T[] {
    const arrayWithoutDuplicates = arrayWithDuplicates.filter((value, index, self) => {
        return index === self.findIndex((element) => element[key] === value[key]);
    });

    return arrayWithoutDuplicates;
}
